/** L'identité du client est-elle en règle pour le registre ? */
export function identiteComplete(deposant) {
    return deposant.identiteValidee || Boolean(deposant.dateNaissance && deposant.numIdentite);
}
/** Titres proposés à la saisie — l'ancien logiciel a un champ « Titre ». */
export const TITRES = ['', 'M.', 'Mme', 'Mlle', 'Société'];
/** « Rue du Vallon 50, B-6700 Arlon » — l'adresse sur une ligne. */
export function adresseComplete(deposant) {
    const localite = [deposant.codePostal && `${deposant.pays}-${deposant.codePostal}`, deposant.ville]
        .filter(Boolean)
        .join(' ');
    return [deposant.adresse, localite].filter(Boolean).join(', ');
}
//# sourceMappingURL=types.js.map